/**
 * Builds a maps URL from an already-formatted address string.
 * Returns null when there's nothing meaningful to search for.
 */
export function buildAddressMapUrl(addressText: string, isMobile: boolean): string | null {
  const trimmed = addressText?.trim();
  if (!trimmed) return null;

  const encoded = encodeURIComponent(trimmed);
  return isMobile
    ? `geo:0,0?q=${encoded}`
    : `https://www.google.com/maps/search/?api=1&query=${encoded}`;
}
